import "./heroBolt.scss";
import * as utils from "shell/app/app.utils";
import { useEffect, useRef } from "react";

interface heroBoltProps {}

const HeroBolt: React.FC<heroBoltProps> = (props) => {
  const aFrame = useRef<any>();
  const boltRef = useRef<HTMLImageElement>(null);
  const elRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const render = () => {
      if (elRef.current) {
        const vpY = utils.clamp(window.rcScrollY / (window.innerHeight * 0.25));
        elRef.current.style.setProperty("--progress", vpY.toFixed(5));
      }
      // boltRef.current && (boltRef.current.style.transform = `translateY(-${window.rcScrollY}px)`);
      aFrame.current = requestAnimationFrame(render);
    };

    aFrame.current = requestAnimationFrame(render);
    return () => cancelAnimationFrame(aFrame.current);
  }, []);

  return (
    <div className="hero-bolt" ref={elRef}>
      <div className="hero-bolt__gradient">
        <div className="hero-bolt__gradient-inner" />
      </div>
      <div className="hero-bolt__container">
        <img
          src={utils.assetPath("/images/hero-flash-flair.png")}
          className="hero-bolt__image"
          ref={boltRef}
          alt=""
        />
      </div>
    </div>
  );
};

export default HeroBolt;
